module.exports = __webpack_public_path__ + "img/road-transparent.d022e3b9.png";